"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "border-bottom" };
const _hoisted_2 = {
    key: 0,
    class: "d-flex flex-wrap mb-1"
};
const _hoisted_3 = { class: "role-section-chip-wrapper" };
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "text-ellipsis" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "m-top" };
const _hoisted_8 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "text-ellipsis" };
const _hoisted_11 = { key: 1 };
const vue_3 = require("vue");
const models_1 = require("../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRelationList',
    setup(__props) {
        const subRoles = (0, vue_3.inject)("subRoles");
        const mainRole = (0, vue_3.inject)("mainRole");
        const activeUserData = (0, vue_3.inject)('activeUserData');
        function roleStyle(role) {
            if (!role) {
                return;
            }
            return {
                backgroundColor: `#${role.color ? role.color : models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: !role.color || role.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT ? '' : '#fff'
            };
        }
        function roleLabel(role) {
            if (!role) {
                return;
            }
            if (!role.from && !role.to) {
                return role.name;
            }
            return `${role.name} ${role.from} ~ ${role.to}`;
        }
        const computedSubRoles = (0, vue_3.computed)(() => {
            return subRoles || [];
        });
        const computedMainRole = (0, vue_3.computed)(() => {
            return mainRole;
        });
        const computedActiveUserData = (0, vue_3.computed)(() => {
            return activeUserData || { userId: 0, branchId: 0 };
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("div", { class: "flex-justify-between" }, [
                        (0, vue_2.createElementVNode)("span", null, "メイン業務")
                    ], -1 /* CACHED */)),
                    (computedMainRole.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("a", {
                                    class: "chip c-hand role-section-slot-chip d-flex sub-role-chip",
                                    style: (0, vue_2.normalizeStyle)(roleStyle(computedMainRole.value)),
                                    href: `/dashboard/${computedActiveUserData.value.userId}/role/${computedMainRole.value.id}?c=${computedActiveUserData.value.branchId}`
                                }, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(roleLabel(computedMainRole.value)), 1 /* TEXT */)
                                ], 12 /* STYLE, PROPS */, _hoisted_4)
                            ])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                                (0, vue_2.createElementVNode)("small", { class: "oplus-gray-text" }, "メイン業務がありません", -1 /* CACHED */)
                            ]))]))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", { class: "flex-justify-between" }, [
                        (0, vue_2.createElementVNode)("span", null, "サブ業務")
                    ], -1 /* CACHED */)),
                    (computedSubRoles.value.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(computedSubRoles.value, (subRole) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    class: "role-section-chip-wrapper",
                                    key: subRole.id
                                }, [
                                    (0, vue_2.createElementVNode)("a", {
                                        class: "chip c-hand role-section-slot-chip d-flex sub-role-chip",
                                        style: (0, vue_2.normalizeStyle)(roleStyle(subRole)),
                                        href: `/dashboard/${computedActiveUserData.value.userId}/role/${subRole.id}?c=${computedActiveUserData.value.branchId}`
                                    }, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(roleLabel(subRole)), 1 /* TEXT */)
                                    ], 12 /* STYLE, PROPS */, _hoisted_9)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [...(_cache[2] || (_cache[2] = [
                                (0, vue_2.createElementVNode)("small", { class: "oplus-gray-text" }, "サブ業務がありません", -1 /* CACHED */)
                            ]))]))
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
